<template>
  <div  class=" ">
    
    <table class="table table-striped cart-list ">
      <thead>
        <tr>
          <th style="width:20%">نوع اتاق</th>
          <th>تاریخ </th>
          <th>قیمت </th>
          <th>تعداد </th>
  

        </tr>
      </thead>
      <tbody>
             <tr>
          <td>رويال دريا</td>
          <td>1399/01/01</td>
          <td>1/200/000</td>
          <td>23</td>
 
      
             </tr>
             <tr>
          <td>لوکس دريا دبل</td>
          <td>1399/01/01</td>
          <td>1/200/000</td>
          <td>2</td>
  
      
             </tr>
 
               <tr>
          <td>لوکس دريا دبل</td>
          <td>1399/01/01</td>
          <td>100/000</td>
          <td>2</td>
     
      
             </tr>
                     <tr>
          <td >دو نفره باغ استاندارد</td>
          <td>1399/08/01</td>
          <td>1/200/000</td>
          <td>2</td>
   
      
             </tr>
             
    
      </tbody>
    </table>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.table{
  width: 516px;
}
</style>